import React, {Fragment} from 'react'
import {Link} from "react-router-dom";


const RegsuccesfulScreen = () => {


    return (
        <Fragment>

            <nav className="navbar navbar-expand-lg navbar-light shadow bg-white bg-main fixed-top">
                <div className="container-fluid">
                    <a className="navbar-brand" href="#">

                    </a>
                    <button className="navbar-toggler" type="button" data-toggle="collapse"
                            data-target="#navbarSupportedContent"
                            aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
                        <span className="navbar-toggler-icon"></span>
                    </button>

                    <div className="collapse navbar-collapse" id="navbarSupportedContent">
                        <ul className="navbar-nav mr-auto main-nav-item">
                            <li className="nav-item active">
                                <a className="nav-link" href="#">Home</a>
                            </li>
                            <li className="nav-item">
                                <a className="nav-link" href="#about">About</a>
                            </li>
                            <li className="nav-item">
                                <a className="nav-link" href="#benefits">Benefits</a>
                            </li>
                            <li className="nav-item">
                                <a className="nav-link" href="#features">Features</a>
                            </li>
                            <li className="nav-item">
                                <a className="nav-link" href="#services">Services</a>
                            </li>
                            <li className="nav-item">
                                <a className="nav-link" href="#testify">Testimonial</a>
                            </li>
                            <li className="nav-item">
                                <a className="nav-link" href="#partners">Parnters</a>
                            </li>
                        </ul>
                        <ul className="navbar-nav ml-auto">
                            <li className="nav-item active">
                                <Link to="/login"
                                      className="nav-link btn btn-gravity-secondary btn-sm text-white px-3 mr-lg-3 mb-1-sm make-medium">
                                    Log In to Dashboard
                                    <span className="sr-only">(current)</span>
                                </Link>
                            </li>
                            <li className="nav-item active">
                                <Link to="/register"
                                      className="nav-link btn btn-orange btn-sm make-medium text-white px-3 mb-1-sm">
                                    Sign Up
                                    <span className="sr-only">(current)</span>
                                </Link>
                            </li>
                        </ul>
                    </div>
                </div>
            </nav>

            <div className="intro-banner  text-white d-flex justify-content-center align-items-center vh-100-lg">
                <div className="container">
                    <div className="row align-items-center">
                        <div className="col-lg-5">
                            <h2 className="mb-4 ft-lg make-bold text-white">Leading Equipment Hailing App in
                                Nigeria</h2>
                            <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Eos vel distinctio, optio labore
                                unde
                                consequatur temporibus sequi atque, quam quae cumque eaque rerum rem animi dignissimos
                                nihil
                                soluta alias? Incidunt?</p>
                        </div>
                    </div>
                </div>
            </div>

            <div className="about-us-sect vh-100-lg d-flex justify-content-center align-items-center" id="about">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-7 mx-auto">
                            <h2 className="text-orange make-bold">About Us</h2>
                            <p>Lorem ipsum dolor sit, amet consectetur adipisicing elit. Eos hic voluptates aliquid
                                tenetur
                                rerum praesentium ducimus facilis modi dignissimos, molestiae laborum illum nam! Culpa
                                tempore
                                possimus, suscipit laudantium ex distinctio. Lorem ipsum dolor sit, amet consectetur
                                adipisicing
                                elit. Dignissimos nostrum officia nesciunt, soluta corporis, nulla libero quo amet
                                accusamus
                                numquam quaerat. Magnam quae unde necessitatibus officia illo pariatur sunt beatae.</p>
                        </div>
                    </div>
                </div>
            </div>

            <div className="next-section vh-100-lg d-flex justify-content-center align-items-center bg-dark green"
                 id="benefits">
                <div className="container">
                    <div className="row mb-4">
                        <div className="col-lg-6">
                            <p className="text-uppercase mb-0 text-orange">What we offer</p>
                            <h2 className="ft-md text-gravity-secondary">Benefits of equipment hailing
                            </h2>
                        </div>
                    </div>
                    <div className="row text-center">
                        <div className="col-lg-4 col-12 mb-3">
                            <div className="card h-100 border-0 shadow">
                                <div className="card-body">
                                    <img src="images/arrow.png" className="img-fluid mb-4" width="50"/>
                                    <h6 className="make-medium">Benefit #1</h6>
                                    <p className="text-muted">Lorem ipsum dolor sit amet consectetur adipisicing elit.
                                        Perspiciatis
                                        in est voluptatibus vero itaque id ex maxime eveniet enim repellat deserunt,
                                        eligendi
                                        natus dolor, fuga mollitia, voluptatem beatae rem obcaecati.</p>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-4 col-12 mb-3">
                            <div className="card h-100 border-0 shadow">
                                <div className="card-body">
                                    <img src="images/arrow.png" className="img-fluid mb-4" width="50"/>
                                    <h6 className="make-medium">Benefit #1</h6>
                                    <p className="text-muted">Lorem ipsum dolor sit amet consectetur adipisicing elit.
                                        Perspiciatis
                                        in est voluptatibus vero itaque id ex maxime eveniet enim repellat deserunt,
                                        eligendi
                                        natus dolor, fuga mollitia, voluptatem beatae rem obcaecati.</p>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-4 col-12 mb-3">
                            <div className="card h-100 border-0 shadow">
                                <div className="card-body">
                                    <img src="images/arrow.png" className="img-fluid mb-4" width="50"/>
                                    <h6 className="make-medium">Benefit #1</h6>
                                    <p className="text-muted">Lorem ipsum dolor sit amet consectetur adipisicing elit.
                                        Perspiciatis
                                        in est voluptatibus vero itaque id ex maxime eveniet enim repellat deserunt,
                                        eligendi
                                        natus dolor, fuga mollitia, voluptatem beatae rem obcaecati.</p>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-4 col-12 mb-3">
                            <div className="card h-100 border-0 shadow">
                                <div className="card-body">
                                    <img src="images/arrow.png" className="img-fluid mb-4" width="50"/>
                                    <h6 className="make-medium">Benefit #1</h6>
                                    <p className="text-muted">Lorem ipsum dolor sit amet consectetur adipisicing elit.
                                        Perspiciatis
                                        in est voluptatibus vero itaque id ex maxime eveniet enim repellat deserunt,
                                        eligendi
                                        natus dolor, fuga mollitia, voluptatem beatae rem obcaecati.</p>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-4 col-12 mb-3">
                            <div className="card h-100 border-0 shadow">
                                <div className="card-body">
                                    <img src="images/arrow.png" className="img-fluid mb-4" width="50"/>
                                    <h6 className="make-medium">Benefit #1</h6>
                                    <p className="text-muted">Lorem ipsum dolor sit amet consectetur adipisicing elit.
                                        Perspiciatis
                                        in est voluptatibus vero itaque id ex maxime eveniet enim repellat deserunt,
                                        eligendi
                                        natus dolor, fuga mollitia, voluptatem beatae rem obcaecati.</p>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-4 col-12 mb-3">
                            <div className="card h-100 border-0 shadow">
                                <div className="card-body">
                                    <img src="images/arrow.png" className="img-fluid mb-4" width="50"/>
                                    <h6 className="make-medium">Benefit #1</h6>
                                    <p className="text-muted">Lorem ipsum dolor sit amet consectetur adipisicing elit.
                                        Perspiciatis
                                        in est voluptatibus vero itaque id ex maxime eveniet enim repellat deserunt,
                                        eligendi
                                        natus dolor, fuga mollitia, voluptatem beatae rem obcaecati.</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="features-sect vh-100-lg d-flex justify-content-center align-items-center" id="features">
                <div className="container">
                    <div className="row mb-4">
                        <div className="col-lg-8 mx-auto">
                            <p className="text-uppercase mb-0 text-orange">What feature we offer</p>
                            <h2 className="ft-md text-gravity-secondary">Our Unique Features
                            </h2>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-lg-8 mx-auto">
                            <ul className="feature-list">
                                <li>Backed with FDIC
                                    insurance*
                                </li>
                                <li>No hidden fees</li>
                                <li>No monthly fees or
                                    minimum balance
                                    requirements
                                </li>
                                <li>Simple, easy-to-use
                                    mobile apps
                                </li>
                                <li>Apply in under 10
                                    minutes
                                </li>
                                <li>Human-powered
                                    customer service
                                </li>
                                <li>Free transfers,
                                    mailed checks, and
                                    incoming wires
                                </li>
                                <li>Integrates with other
                                    small business
                                    tools
                                </li>
                                <li>Refunds all ATM fees
                                </li>
                                <li>Thousands of dollars
                                    in exclusive perks
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>

            <div className="more-features bg-dark-green vh-100-lg d-flex justify-content-center align-items-center"
                 id="services">
                <div className="container">
                    <div className="row mb-4">
                        <div className="col-lg-6">
                            <p className="text-uppercase mb-0 text-orange">What services we provide for you</p>
                            <h2 className="ft-md text-gravity-secondary">Our Services
                            </h2>
                        </div>
                    </div>
                    <hr/>
                    <div className="row align-items-center">
                        <div className="col-lg-3 mb-3">
                            <div className="text-white mb-4">
                                <h5 className="text-orange make-bold">Drone Mapping</h5>
                                <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Tenetur laboriosam, ipsum
                                    dolore
                                    impedit necessitatibus nihil, eveniet officiis minus illum, officia corrupti
                                    assumenda nam
                                    mollitia optio repudiandae earum corporis quisquam tempora! </p>
                                <a href="#" className="text-info">Learn More</a>
                            </div>
                        </div>
                        <div className="col-lg-3 mb-3">
                            <div className="text-white mb-4">
                                <h5 className="text-orange make-bold">Soil Testing</h5>
                                <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Tenetur laboriosam, ipsum
                                    dolore
                                    impedit necessitatibus nihil, eveniet officiis minus illum, officia corrupti
                                    assumenda nam
                                    mollitia optio repudiandae earum corporis quisquam tempora! </p>
                                <a href="#" className="text-info">Learn More</a>
                            </div>
                        </div>
                        <div className="col-lg-3 mb-3">
                            <div className="text-white mb-4">
                                <h5 className="text-orange make-bold">Harvesting</h5>
                                <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Tenetur laboriosam, ipsum
                                    dolore
                                    impedit necessitatibus nihil, eveniet officiis minus illum, officia corrupti
                                    assumenda nam
                                    mollitia optio repudiandae earum corporis quisquam tempora! </p>
                                <a href="#" className="text-info">Learn More</a>
                            </div>
                        </div>
                        <div className="col-lg-3 mb-3">
                            <div className="text-white mb-4">
                                <h5 className="text-orange make-bold">Satelite Monitoring</h5>
                                <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Tenetur laboriosam, ipsum
                                    dolore
                                    impedit necessitatibus nihil, eveniet officiis minus illum, officia corrupti
                                    assumenda nam
                                    mollitia optio repudiandae earum corporis quisquam tempora! </p>
                                <a href="#" className="text-info">Learn More</a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="testimonial-sect d-flex justify-content-center align-items-center vh-100-lg" id="testify">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-8 mx-auto mb-4">
                            <div className="text-center mb-3">
                                <p>You can ask the thousands of business owners
                                    using AppName or you can sign up yourself</p>
                            </div>
                            <h1 className="text-gravity-secondary text-center ft-2">Happy customers sharing their
                                Experience</h1>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-lg-10 mx-auto">
                            <div id="carouselTestifyIndicators" className="carousel slide" data-ride="carousel">
                                <ol className="carousel-indicators indicator--bottom">
                                    <div className="testifyAvatar bord-radius-50 mb-3 cursor"
                                         data-target="#carouselTestifyIndicators" data-slide-to="0">
                                        <img src="images/testify.jpg"
                                             className="img-fluid ob-fit h-100 w-100 opacity-3"/>
                                    </div>
                                    <div className="testifyAvatar bord-radius-50 mb-3 cursor"
                                         data-target="#carouselTestifyIndicators" data-slide-to="1">
                                        <img src="images/testify-3.jpg"
                                             className="img-fluid ob-fit h-100 w-100 opacity-3"/>
                                    </div>
                                    <div className="testifyAvatar bord-radius-50 mb-3 cursor active"
                                         data-target="#carouselTestifyIndicators" data-slide-to="2">
                                        <img src="images/testify-2.jpg"
                                             className="img-fluid ob-fit h-100 w-100 opacity-3"/>
                                    </div>
                                </ol>

                                <div className="carousel-inner">
                                    <div className="carousel-item">
                                        <div className="testify-carousel-info">
                                            <div className="row align-items-center">
                                                <div className="col-lg-7 mb-3">
                                                    <p className="testify-text">Lorem ipsum dolor sit amet, consectetur
                                                        adipisicing
                                                        elit. Tempora soluta minus voluptates voluptatem praesentium,
                                                        temporibus
                                                        laboriosam saepe dolore ullam pariatur a qui! Rem deleniti sed
                                                        inventore
                                                        rerum incidunt accusantium illo!
                                                    </p>
                                                    <h4 className="make-bold text-gravity-secondary">Francis
                                                        Jobidon</h4>
                                                    <p>Co-founder - key account manager</p>
                                                </div>
                                                <div className="col-lg-5 mb-3">
                                                    <div className="testify-image bord-radius-50 mx-auto">
                                                        <img src="images/testify.jpg"
                                                             className="img-fluid ob-fit w-100 h-100"/>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="carousel-item">
                                        <div className="testify-carousel-info">
                                            <div className="row align-items-center">
                                                <div className="col-lg-7 mb-3">
                                                    <p className="testify-text">Lorem ipsum, dolor sit amet consectetur
                                                        adipisicing
                                                        elit. Ducimus quibusdam, molestias vel sequi est unde deleniti.
                                                        Aperiam,
                                                        ea veritatis! Perspiciatis error aliquid velit quis ipsam? Nulla
                                                        placeat
                                                        sed at rerum.
                                                    </p>
                                                    <h4 className="make-bold text-gravity-secondary">Francis
                                                        Jobidon</h4>
                                                    <p>Co-founder - key account manager</p>
                                                </div>
                                                <div className="col-lg-5 mb-3 mx-auto">
                                                    <div className="testify-image bord-radius-50 mx-auto">
                                                        <img src="images/testify-3.jpg"
                                                             className="img-fluid ob-fit w-100 h-100"/>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="carousel-item active">
                                        <div className="testify-carousel-info">
                                            <div className="row align-items-center">
                                                <div className="col-lg-7 mb-3">
                                                    <p className="testify-text">Lorem ipsum dolor sit amet consectetur
                                                        adipisicing
                                                        elit. Optio labore nobis obcaecati corrupti ipsam quo fugit
                                                        quasi id
                                                        aliquam repellat architecto perspiciatis maiores iusto accusamus
                                                        velit
                                                        fuga, nesciunt assumenda magni!
                                                    </p>
                                                    <h4 className="make-bold text-gravity-secondary">Adigun
                                                        Olayinka</h4>
                                                    <p>Job Seeker</p>
                                                </div>
                                                <div className="col-lg-5 mb-3 mx-auto">
                                                    <div className="testify-image bord-radius-50 mx-auto">
                                                        <img src="images/testify-2.jpg"
                                                             className="img-fluid ob-fit w-100 h-100"/>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <a href="#" className="text-uppercase lt-2 btn btn-link btn-sm">See more customer stories</a>
                </div>
            </div>

            <div className="partners-sect vh-100-lg bg-light d-flex justify-content-center align-items-center"
                 id="partners">
                <div className="container">
                    <div className="row mb-4">
                        <div className="col-lg-7 mx-auto">
                            <p className="text-uppercase mb-0 text-orange">Who are our partners</p>
                            <h2 className="ft-md text-gravity-secondary">Our Partners
                            </h2>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-lg-7 mx-auto">
                            <div className="grid-tools">
                                <div className="grid-tool-item">
                                    <div className="card-image-holder-idea-4 bord-rad-10">
                                        <img src="images/partner.jpg" className="card-img-top w-100 h-100 obj-fit"
                                             alt="..."/>
                                    </div>
                                </div>
                                <div className="grid-tool-item">
                                    <div className="card-image-holder-idea-4 bord-rad-10">
                                        <img src="images/partner.jpg" className="card-img-top w-100 h-100 obj-fit"
                                             alt="..."/>
                                    </div>
                                </div>
                                <div className="grid-tool-item">
                                    <div className="card-image-holder-idea-4 bord-rad-10">
                                        <img src="images/partner.jpg" className="card-img-top w-100 h-100 obj-fit"
                                             alt="..."/>
                                    </div>
                                </div>
                                <div className="grid-tool-item">
                                    <div className="card-image-holder-idea-4 bord-rad-10">
                                        <img src="images/partner.jpg" className="card-img-top w-100 h-100 obj-fit"
                                             alt="..."/>
                                    </div>
                                </div>
                                <div className="grid-tool-item">
                                    <div className="card-image-holder-idea-4 bord-rad-10">
                                        <img src="images/partner.jpg" className="card-img-top w-100 h-100 obj-fit"
                                             alt="..."/>
                                    </div>
                                </div>
                                <div className="grid-tool-item">
                                    <div className="card-image-holder-idea-4 bord-rad-10">
                                        <img src="images/partner.jpg" className="card-img-top w-100 h-100 obj-fit"
                                             alt="..."/>
                                    </div>
                                </div>
                                <div className="grid-tool-item">
                                    <div className="card-image-holder-idea-4 bord-rad-10">
                                        <img src="images/partner.jpg" className="card-img-top w-100 h-100 obj-fit"
                                             alt="..."/>
                                    </div>
                                </div>
                                <div className="grid-tool-item">
                                    <div className="card-image-holder-idea-4 bord-rad-10">
                                        <img src="images/partner.jpg" className="card-img-top w-100 h-100 obj-fit"
                                             alt="..."/>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <footer className="bg-dark-green py-100">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-6 mb-3">

                            <ul className="list-unstyled footer-links">
                                <li><a href="#">(E): support@test.cpm</a>
                                </li>
                                <li><a href="#">(T): 080x-xxx-xxxx</a>
                                </li>
                            </ul>
                            <ul className="list-unstyled d-flex footer-links text-white">
                                <li>40b Wole Ariyo Street, Off Admirality Way, Lekki Phase 1, Lagos</li>
                            </ul>
                        </div>
                        <div className="col-lg-3 mb-3">
                            <h4 className="make-bold text-white">Our Company</h4>
                            <ul className="list-unstyled footer-links">
                                <li><a href="#">About us</a></li>
                                <li><a href="#">FAQ</a></li>
                                <li><a href="#">Pricing</a></li>
                                <li><a href="#">Help</a></li>
                                <li><a href="#">Partners</a></li>
                                <li><a href="#">press</a></li>
                            </ul>
                        </div>
                        <div className="col-lg-3 mb-3">
                            <h4 className="make-bold text-white">Our Policy</h4>
                            <ul className="list-unstyled footer-links">
                                <li><a href="#">Terms and Conditions</a></li>
                                <li><a href="#">Privacy Policy</a></li>
                                <li><a href="#">Disclaimer</a></li>
                                <li><a href="#">Security</a></li>
                            </ul>
                        </div>
                        <div className="col-lg-12 text-white text-right">
                            <hr/>
                            <small>&copy; 2021 App Name. All rights reserved.</small>
                        </div>
                    </div>
                </div>
            </footer>

        </Fragment>

    )
}
export default RegsuccesfulScreen